import React from 'react';
import { IBasicButton } from '../../../interfaces/buttons/buttons';


const BasicButton = ({ content, ariaLabel, className, isClassicThriveStyle = false, isDisabled = false, onButtonClick, isLink, linkUrl, openInNewTab = false,}: IBasicButton) => {

    if (isLink) {
        return (
            <a
            className={`basic-button ${isClassicThriveStyle && 'classic-style-button'} ${className ?? ""} ${isDisabled && "disabled-style-link"}`}
            aria-label={ariaLabel}
            href={linkUrl}
            target={openInNewTab ? "_blank" : undefined}
            rel={openInNewTab ? "noopener noreferrer" : undefined}
        >
            {content}
        </a>
        )
    }
    return (
        <button
            className={`basic-button ${isClassicThriveStyle && 'classic-style-button'} ${className ?? ""}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type={'button'}
        >
            {content}
        </button>
    );
};

export default BasicButton